import { useEffect } from 'react'
import { Outlet } from '@tanstack/react-router'
import { ErrorBoundary } from 'react-error-boundary'
import { TooltipProvider } from '@/react/ui/tooltip'
import { uiActions } from '@/core/state/ui'
import { userActions } from '@/core/state/user'
import { AppBar } from './AppBar'
import { LoadingOverlay } from './LoadingOverlay'
import { Snackbar } from './Snackbar'
import { ErrorFallback } from './ErrorFallback'
import './frame.css'

/** The root route: App.vue's chrome around whatever the route renders. */
export function AppFrame() {
  // App.vue's onMounted: every modal closed on a fresh load, then the session
  // validated. A child's effects run before its parent's, so the island has
  // already mounted here — the same order the Vue app had.
  useEffect(() => {
    uiActions.closeAllModals()
    void userActions.init()
  }, [])

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) => console.error('[frame] render error', error, info.componentStack)}
    >
      <TooltipProvider>
        <AppBar />
        <Outlet />
        <LoadingOverlay />
        <Snackbar />
      </TooltipProvider>
    </ErrorBoundary>
  )
}
